// libs
import React, { memo, useCallback } from 'react';

// global components
import { useOverlaySheetContext } from 'shared/components/OverlaySheet/OverlaySheetContext';
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

// helpers
import { getGiftCardRemoteConfig } from './helpers';

// styles
import {
  Container,
  Image,
  Title,
  Desc,
  ActionCont,
  PrimaryButton,
  SecondaryButton,
} from './styles';

// defs
interface ConfirmationProps {
  onCancel: VoidFunction;
  onConfirm: VoidFunction;
}

const IMAGE_HEIGHT = 48;
const IMAGE_WIDTH = 49;

function Confirmation({ onCancel, onConfirm }: ConfirmationProps) {
  const { doHide } = useOverlaySheetContext();
  const { title, desc, logo, confirmText, cancelText } = getGiftCardRemoteConfig(
    useRemoteConfig('nykaaGiftcard')
  );

  const onConfirmClick = useCallback(() => {
    doHide();
    onConfirm();
  }, [doHide, onConfirm]);

  const onCancelClick = useCallback(() => {
    doHide();
    onCancel();
  }, [doHide, onCancel]);

  return (
    <Container>
      <Image src={logo} alt="nykaa logo" width={IMAGE_WIDTH} height={IMAGE_HEIGHT} />
      <Title>{title}</Title>
      <Desc>{desc}</Desc>

      <ActionCont>
        <SecondaryButton onClick={onCancelClick}>{cancelText}</SecondaryButton>
        <PrimaryButton onClick={onConfirmClick}>{confirmText}</PrimaryButton>
      </ActionCont>
    </Container>
  );
}

export default memo(Confirmation);
